import React from 'react';
import { Box, Stack } from '@mui/material';

import { AuthSide, TextSide } from '@/features/account';
import palette from '@/theme/palette.ts';

import { styles } from './styles.ts';

export const AuthPage = () => {
  return (
    <Box sx={styles.container}>
      <Stack direction="column" alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
        <TextSide />
      </Stack>
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          ...styles.authContainer,
          backgroundColor: palette.surface.lightest,
        }}
      >
        <AuthSide />
      </Stack>
    </Box>
  );
};
